<template>
  <div v-show="selected_day_schedule_id !== 0">
    <div class="form-group row">
      <div class="col-7" v-if="is_authenticated">
        <div class="btn-group">
          <router-link
            :to="{ name: 'AddDayScheduleItem', params: { day_schedule_id: selected_day_schedule_id } }"
            class="btn btn-success"
          >
            <i class="fa fa-edit" aria-hidden="true"></i> Add Bell
          </router-link>
          <button
            type="button"
            class="btn btn-success dropdown-toggle dropdown-toggle-split"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          ></button>
          <div class="dropdown-menu">
            <router-link
              :to="{ name: 'AddDayScheduleItemAtInterval', params: { day_schedule_id: selected_day_schedule_id } }"
              class="dropdown-item"
            >
              <i class="fa fa-edit" aria-hidden="true"></i> Add Bell at Interval
            </router-link>
            <router-link
              :to="{ name: 'CopyDayScheduleItemsZone', params: { day_schedule_id: selected_day_schedule_id } }"
              class="dropdown-item"
            >
              <i class="fa fa-clone" aria-hidden="true"></i> Copy Zone Schedule
            </router-link>
          </div>
        </div>
        <button class="btn btn-danger" @click="deleteDayScheduleItemByIds">
          <i class="fa fa-dumpster" aria-hidden="true"></i> Delete Selected
        </button>
        <button class="btn btn-secondary" @click="selectAllCheckboxes">
          <i class="fa fa-check-square" aria-hidden="true"></i> Select All
        </button>
      </div>
      <div class="col-7" v-else>
        <router-link :to="{ name: 'Home' }" class="btn btn-sm btn-light">
          <i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i> Back to Calendar
        </router-link>
      </div>
      <label class="col-1 col-form-label d-none d-md-table-cell" for="ddlZone">Zone Filter</label>
      <div class="col-4 d-none d-md-table-cell">
        <select
          class="form-control"
          id="ddlZone"
          v-model="selectedZoneId"
          @change="loadDayScheduleItems(1)"
        >
          <option value="0">No Filter</option>
          <option
            v-for="zone in zones"
            :key="zone.zone_id"
            v-bind:value="zone.zone_id"
          >{{ zone.name }}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
            <tr>
              <th></th>
              <th>Schedule Time</th>
              <th class="d-none d-md-table-cell">Description</th>
              <th>Zone</th>
              <th class="d-none d-md-table-cell">Sound/Playlist</th>
              <th>Manage</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="day_schedule_item in day_schedule_items"
              :key="day_schedule_item.day_schedule_item_id"
            >
              <td>
                <input
                  type="checkbox"
                  v-model="day_schedule_items_checkboxes[day_schedule_item.day_schedule_item_id]"
                  @click="toggleCheckbox(day_schedule_item.day_schedule_item_id)"
                />
              </td>
              <td>{{ day_schedule_item.schedule_time }}</td>
              <td class="d-none d-md-table-cell">
                <span
                  v-if="day_schedule_item.description !== ''"
                >{{ day_schedule_item.description }}</span>
                <span v-else>N/A</span>
              </td>
              <td class="d-none d-md-table-cell" v-if="day_schedule_item.zones.length > 0">
                <button
                  type="button"
                  class="btn btn-light"
                  @click="toggleZones(day_schedule_item.day_schedule_item_id)"
                >{{ ((day_schedule_items_showing_zones.includes(day_schedule_item.day_schedule_item_id)) ? 'Hide' : 'Show') }} Zones</button>
                <div
                  v-if="day_schedule_items_showing_zones.includes(day_schedule_item.day_schedule_item_id)"
                >
                  <br />
                  <table class="table">
                    <tbody>
                      <tr v-for="zone in day_schedule_item.zones" :key="zone.zone_id">
                        <td>
                          <span v-if="scoped_site_id === 1">[{{ zone.site.name }}]</span>
                          {{ zone.name }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
              <td v-else>N/A</td>
              <td
                class="d-none d-md-table-cell"
                v-if="day_schedule_item.sound_type_id === 1"
              >{{ day_schedule_item.sound.filename }}</td>
              <td
                class="d-none d-md-table-cell"
                v-else-if="[2,3,4].includes(day_schedule_item.sound_type_id)"
              >{{ day_schedule_item.playlist.name }} ({{ day_schedule_item.sound_type.name }})</td>
              <td>
                <div class="dropdown">
                  <button
                    class="btn btn-light dropdown-toggle"
                    type="button"
                    id="ddlDayScheduleItemManage"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
                  </button>
                  <div class="dropdown-menu" aria-labelledby="ddlDayScheduleItemManage">
                    <router-link
                      :to="{ name:'EditDayScheduleItem', params: { day_schedule_item_id: day_schedule_item.day_schedule_item_id } }"
                      class="dropdown-item"
                    >
                      <i class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i>&nbsp;Edit
                    </router-link>
                    <a
                      class="dropdown-item"
                      href="#"
                      onclick="return false"
                      @click="deleteDayScheduleItem(day_schedule_item.day_schedule_item_id)"
                    >
                      <i class="fa fa-trash fa-fw" aria-hidden="true"></i>&nbsp;Delete
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <nav>
          <ul class="pagination">
            <li
              class="page-item"
              v-for="n in day_schedule_items_total_pages"
              :key="n"
              :class="{ 'active': n == day_schedule_items_current_page }"
            >
              <a class="page-link" href="#" onclick="return false" @click="loadDayScheduleItems(n)">
                {{ n
                }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    selected_day_schedule_id: {
      type: Number,
      required: true
    }
  },
  data: function () {
    return {
      selectedZoneId: '0',
      day_schedule_items_checkbox_on: [],
      day_schedule_items_showing_zones: []
    }
  },
  computed: {
    ...mapGetters({
      scoped_site_id: 'scopedSiteId',
      zones: 'allZones',
      day_schedule_items: 'allDayScheduleItems',
      day_schedule_items_total_pages: 'dayScheduleItemsTotalPages',
      day_schedule_items_current_page: 'dayScheduleItemsCurrentPage',
      is_authenticated: 'isAuthenticated'
    }),
    day_schedule_items_checkboxes () {
      let temp = {}

      for (let dayScheduleItem of this.day_schedule_items) {
        temp[dayScheduleItem.day_schedule_item_id] = this.day_schedule_items_checkbox_on.find(
          ele => ele === dayScheduleItem.day_schedule_item_id
        )
      }

      return temp
    }
  },
  created () {
    this.$store.dispatch('getDaySchedules')
    if (this.selected_day_schedule_id !== 0) {
      this.loadDayScheduleItems(1)
    }
    this.$store.dispatch('getZones')
    this.$store.dispatch('getSounds')
  },
  watch: {
    selected_day_schedule_id: function (newValue) {
      if (newValue !== 0) {
        this.loadDayScheduleItems(1)
      } else {
        this.$store.dispatch('setDisabledChangeScopedSite', false)
      }
    }
  },
  methods: {
    loadDayScheduleItems (page) {
      this.$store.dispatch('setDisabledChangeScopedSite', true)
      this.$store.dispatch('getDayScheduleItems', {
        dayScheduleId: this.selected_day_schedule_id,
        zone_id: this.selectedZoneId,
        page: page
      })
      this.day_schedule_items_checkbox_on = []
    },
    toggleZones (dayScheduleItemId) {
      if (this.day_schedule_items_showing_zones.includes(dayScheduleItemId)) {
        this.day_schedule_items_showing_zones.splice(
          this.day_schedule_items_showing_zones.indexOf(dayScheduleItemId),
          1
        )
      } else {
        this.day_schedule_items_showing_zones.push(dayScheduleItemId)
      }
    },
    toggleCheckbox (dayScheduleItemId) {
      if (this.day_schedule_items_checkbox_on.includes(dayScheduleItemId)) {
        this.day_schedule_items_checkbox_on.splice(
          this.day_schedule_items_checkbox_on.indexOf(dayScheduleItemId),
          1
        )
      } else {
        this.day_schedule_items_checkbox_on.push(dayScheduleItemId)
      }
    },
    selectAllCheckboxes () {
      this.day_schedule_items_checkbox_on = this.day_schedule_items.map(
        dayScheduleItem => dayScheduleItem.day_schedule_item_id
      )
    },
    deleteDayScheduleItem (dayScheduleItemId) {
      this.$store.dispatch('deleteDayScheduleItem', dayScheduleItemId)
    },
    deleteDayScheduleItemByIds () {
      this.$store.dispatch('deleteDayScheduleItemByIds', this.day_schedule_items_checkbox_on)
      this.day_schedule_items_checkbox_on = []
    }
  }
}
</script>
